import { render, staticRenderFns } from "./resultModal.vue?vue&type=template&id=444fc0dc&"
import script from "./resultModal.vue?vue&type=script&lang=js&"
export * from "./resultModal.vue?vue&type=script&lang=js&"
import style0 from "./resultModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports